import React from "react";

export function Card({ title, subtitle, actions, footer, padding = "var(--pad-kaart)", style, children }) {
  return (
    <div style={{ background: "var(--surface-card)", border: "1px solid var(--border-subtle)",
      borderRadius: "var(--radius-vlak)", boxShadow: "var(--elevation-card)", ...style }}>
      {(title || actions) ? (
        <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between",
          gap: "var(--ruimte-5)", padding: padding, paddingBottom: children ? "var(--ruimte-5)" : padding }}>
          <div>
            {title ? <div style={{ font: "var(--text-h3)", color: "var(--text-strong)" }}>{title}</div> : null}
            {subtitle ? <div style={{ marginTop: 2, fontSize: "var(--fs-sm)", color: "var(--text-soft)" }}>{subtitle}</div> : null}
          </div>
          {actions}
        </div>
      ) : null}
      {children ? <div style={{ padding: padding, paddingTop: (title || actions) ? 0 : padding }}>{children}</div> : null}
      {footer ? <div style={{ borderTop: "1px solid var(--border-subtle)", padding: "var(--ruimte-5) " + "var(--pad-kaart)" }}>{footer}</div> : null}
    </div>
  );
}
